export default __webpack_public_path__ + "static/media/Jamming.80e03700.PNG";